/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Divider, Grid, Typography2 } from '@coursera/cds-core';

import type { AdditionalContent } from './ValuePropositionComponent';

type ValuePropositionItemProps = {
  content: AdditionalContent;
  displayText: string;
  number?: string;
  label?: string;
  hasMoreItems: boolean;
  isSmallScreen: boolean;
  hasIcons: boolean;
};

const styles = {
  icon: css`
    margin-right: var(--cds-spacing-100);
  `,
  iconLessItem: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,
  iconLessItemSmallScreen: css`
    display: flex;
    flex-direction: row;
    gap: var(--cds-spacing-100);
  `,
  smallScreenItem: css`
    display: flex;
    align-items: center;
  `,
  dividerSpacing: css`
    margin: 0 var(--cds-spacing-100);
  `,
};

const ValuePropositionItem = ({
  content,
  displayText,
  number,
  label,
  hasMoreItems,
  isSmallScreen,
  hasIcons,
}: ValuePropositionItemProps) => {
  if (isSmallScreen && hasIcons) {
    return (
      <Grid item key={displayText} css={styles.smallScreenItem}>
        <Typography2 component="span" variant="bodyPrimary" color="supportText">
          {displayText}
          {hasMoreItems && ','}
        </Typography2>
      </Grid>
    );
  }

  if (!isSmallScreen && hasIcons) {
    return (
      <React.Fragment key={displayText}>
        <Grid item>
          <div css={styles.icon}>{content.icon}</div>
          <Typography2 component="span" variant="bodyPrimary" color="supportText">
            {displayText}
          </Typography2>
        </Grid>
        {hasMoreItems && <Divider color="light" orientation="vertical" />}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment key={displayText}>
      <div css={isSmallScreen ? styles.iconLessItemSmallScreen : styles.iconLessItem}>
        <Typography2 component="span" variant="subtitleLarge" color="body">
          {number}
        </Typography2>
        <Typography2 component="span" variant="bodyPrimary" color="supportText">
          {label}
        </Typography2>
      </div>
      {hasMoreItems && (
        <Divider color="light" orientation="vertical" css={isSmallScreen ? styles.dividerSpacing : undefined} />
      )}
    </React.Fragment>
  );
};

export default ValuePropositionItem;
